import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SignupComponent } from './pages/signup/signup.component';

@NgModule({
    declarations: [SignupComponent],
    imports: [CommonModule, ReactiveFormsModule, RouterModule],
})
export class SignupModule {}
